import {
  FetchCreateSalaryCardFailureAction,
  FetchCreateSalaryCardRequestAction,
  FetchCreateSalaryCardSuccessAction,
  OrderSalaryCardType,
  SalaryCardActions,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'
import { Dispatch } from 'redux'
import { fetchCreateSalaryCardService } from '../../../services/SalaryCards/salaryCards'
import { GlobalErrorActions } from 'store/types/globalError'

export const fetchCreateSalaryCardRequest =
  (): FetchCreateSalaryCardRequestAction => ({
    type: SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_REQUEST,
  })

export const fetchCreateSalaryCardSuccess =
  (): FetchCreateSalaryCardSuccessAction => ({
    type: SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_SUCCESS,
  })

export const fetchCreateSalaryCardFailure = (
  error: any
): FetchCreateSalaryCardFailureAction => ({
  type: SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_FAILURE,
  payload: error,
})

export const fetchCreateSalaryCard = (req: OrderSalaryCardType) => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchCreateSalaryCardRequest())

    try {
      const data = await fetchCreateSalaryCardService(req)
      dispatch(fetchCreateSalaryCardSuccess())
    } catch (error) {
      dispatch(fetchCreateSalaryCardFailure(error.message))
      // dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}
